// constants
import { showSuccessAlert } from "../../constants/alerts";
import { WhoAreWeActionTypes } from "./constants";

const INIT_STATE = {
  whoAreWeData: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface whoAreWeData {
  id: number;
  experience: string;
  users: string;
  courses: string;
}

interface WhoAreWeActionType {
  type:
    | WhoAreWeActionTypes.API_RESPONSE_SUCCESS
    | WhoAreWeActionTypes.API_RESPONSE_ERROR
    | WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA
    | WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA
    | WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA
    | WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA;
  payload: {
    actionType?: string;
    data?: whoAreWeData | {};
    error?: string;
    whoAreWeData?: [];
  };
}

interface State {
  whoAreWeData?: whoAreWeData[] | [];
  loading?: boolean;
  value?: boolean;
}

const WhoAreWeStates = (
  state: State = INIT_STATE,
  action: WhoAreWeActionType
): any => {
  switch (action.type) {
    case WhoAreWeActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            whoAreWeData: action.payload.data,
          };
        }
        case WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case WhoAreWeActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA:
      return { ...state, loading: true };
    case WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA:
      return { ...state, loading: true };
    case WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA:
      return { ...state, loading: true, initialLoading: true };
    case WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default WhoAreWeStates;
